import { Component, OnInit } from '@angular/core';
import { Caller } from '../_models/caller';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.css']
})
export class InfoComponent implements OnInit {

  public titleMessage: string;
  public contactMessage: string;
  public detailMessage: string;
  constructor(public caller: Caller) {
    if (this.caller.parent == 'REGISTER') {
      this.titleMessage = 'Thank you for Registering with Shift Logistics.';
      this.detailMessage = 'We will get back to you soon to discuss your requirements in detail';

    } else if (this.caller.parent == 'LOGIN') {
      this.titleMessage = 'Request in Progress';
      this.detailMessage = 'Your account is still in the process of activation. Please speak to administrator';
    } else if (this.caller.parent == 'FORGOT_PASSWORD') {
      this.titleMessage = 'Request submitted';
      this.detailMessage = 'Please check your email for the password reset link.';
    } else if (this.caller.parent == 'RESET') {
      this.titleMessage = 'Password Reset Successfully';
      this.detailMessage = 'Please login with username and enter new password to login into SHIFT ';
    } else if (this.caller.parent == 'SUCCESS') {
      this.titleMessage = 'Dunzo Webhook';
      this.detailMessage = 'Order Activity updated successfully.';
    } else if (this.caller.parent == 'FAIL') {
      this.titleMessage = 'Dunzo Webhook';
      this.detailMessage = 'No data available for this Order.';
    } else if (!this.caller.parent) {
      this.titleMessage = 'Reload Issue';
      this.detailMessage = 'Reload Issue';
    }
  }

  ngOnInit() {
  }

}
